// src/pages/skills/Skills.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import SkillsTable from "../../components/skills/SkillsTable";

const Skills = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <SkillsTable />
        </WrapperSection>
    );
};

export default Skills;